import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue";
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { MgMenu } from '../menu';
export default {
  __name: 'mg-pop-menu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    left: {
      type: [Number, String],
      default: 0
    },
    top: {
      type: [Number, String],
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    container: {
      type: String,
      default: 'body'
    }
  },
  emits: ['itemClick', 'update:show'],
  setup(__props, {
    emit: __emit
  }) {
    const menuVisible = ref(false);
    const props = __props;
    const emit = __emit;

    // eslint-disable-next-line
    const containerSize = reactive({
      width: -1,
      height: -1
    });
    const popMenuSizeInfo = reactive({
      x: -1,
      // 菜单left
      y: -1,
      // 菜单top
      w: 0,
      // 菜单width
      h: 0,
      // 菜单height
      dir: 'right' // 菜单的子菜单弹出位置
    });
    const menuPopAttr = computed(() => {
      return {
        autoHide: true,
        pos: {
          x: `${popMenuSizeInfo.x}px`,
          y: `${popMenuSizeInfo.y}px`
        },
        direction: popMenuSizeInfo.dir,
        items: props.items
      };
    });
    const handleMenuSize = ({
      width,
      height
    }) => {
      Object.assign(popMenuSizeInfo, {
        w: width,
        h: height
      });
      calcPopMenuPosition();
    };
    const getContainerSize = () => {
      const cel = document.querySelector(props.container);
      if (!cel) return;
      const w = cel.scrollWidth;
      const h = cel.scrollHeight;
      Object.assign(containerSize, {
        width: w,
        height: h
      });
    };

    // 计算菜单弹出位置
    const calcPopMenuPosition = () => {
      const x = Number.parseInt(props.left);
      const y = Number.parseInt(props.top);
      if (Number.isNaN(x) || Number.isNaN(y)) return;
      if (containerSize.width < 0 || containerSize.height < 0 || popMenuSizeInfo.w < 0 || popMenuSizeInfo.h < 0) return;
      let newX = x;
      let newY = y;
      if (x + popMenuSizeInfo.w > containerSize.width) {
        newX -= popMenuSizeInfo.w;
      } else {
        popMenuSizeInfo.dir = 'right';
      }
      if (y + popMenuSizeInfo.h > containerSize.height) {
        newY -= popMenuSizeInfo.h;
      }
      if (newX + popMenuSizeInfo.w * 2 > containerSize.width) {
        popMenuSizeInfo.dir = 'left';
      } else {
        popMenuSizeInfo.dir = 'right';
      }
      popMenuSizeInfo.x = newX;
      popMenuSizeInfo.y = newY;
    };
    const hideMenu = () => {
      menuVisible.value = false;
      emit('update:show', menuVisible.value);
    };
    const handleMenuItemClick = ({
      item,
      $event
    }) => {
      emit('itemClick', {
        item,
        $event
      });
    };
    const handleMenuOutsideClick = () => {
      hideMenu();
    };
    watch(() => props.show, val => {
      menuVisible.value = val;
    }, {
      immediate: true
    });
    onMounted(() => {
      getContainerSize();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: __props.container
      }, [menuVisible.value ? (_openBlock(), _createBlock(_unref(MgMenu), _mergeProps({
        key: 0,
        show: true
      }, menuPopAttr.value, {
        onItemClick: handleMenuItemClick,
        onOutsideClick: handleMenuOutsideClick,
        onMenuSize: handleMenuSize
      }), null, 16)) : _createCommentVNode("", true)], 8, ["to"]);
    };
  }
};